<template>
  <nav class="navbar-wrapper" style="background-color: #24252a;">
    <div class="navbar-content-inner">

      <a href="#" class="d-flex align-items-center text-decoration-none nav-logo-pushed">
        <img :src="logoSecond" style="max-width: 200px; max-height: 70px; padding: 5px 0;" alt="Logo" />
      </a>

      <div id="navigation" class="collapse navbar-collapse w-100 py-lg-0"></div>

      <div class="right-actions-group">
        <div class="dropdown profile-group" v-if="clientName" style="position: relative;">
          <!-- Profile Card -->
          <div class="profile-card" @click="toggleDropdown" style="cursor: pointer;" title="Profil menyusu">
            <div class="profile-image">
              <img :src="userImg" alt="Profile Picture" />
            </div>
            <div class="profile-info" style="display: flex; align-items: center; gap: 6px;">
              <p class="name" style="margin: 0;">{{ clientName }}</p>
              <i class="fas fa-chevron-down" style="font-size: 10px; color: #8392ab; margin-left: 2px;"></i>
            </div>
          </div>

          <!-- Click Outside Overlay (Inside the same stacking context) -->
          <div v-if="showDropdown" @click="showDropdown = false" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 10050; background: transparent;"></div>

          <!-- Dropdown Menu / Toolbar -->
          <div v-if="showDropdown" class="profile-dropdown-menu" style="z-index: 10100;">
            <button @click="SignOut" class="profile-dropdown-btn">
              <i class="fa fa-sign-out-alt" style="color: #ea0606;"></i>
              <span>Etibarlı çıxış</span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </nav>
</template>

<script>
import logoSecond from "@/assets/img/logo.png";
import userImg from "@/assets/img/user.png";

export default {
  name: "Navbar",
  props: {
    clientName: {
      type: String,
      default: ""
    }
  },
  emits: ['print'],
  data() {
    return {
      logoSecond,
      userImg,
      isMenuOpen: false,
      showDropdown: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.body.style.overflow = this.isMenuOpen ? "hidden" : "";
      document.body.style.overflowX = this.isMenuOpen ? "hidden" : "";
    },
    closeMenuOnly() {
      this.isMenuOpen = false;
      document.body.style.overflow = "";
      document.body.style.overflowX = "";
    },
    async SignOut() {
      this.closeMenuOnly();
      this.showDropdown = false;
      try {
        await this.$store.dispatch("logout");
        localStorage.removeItem('report_token');
        this.$router.push("/session/LOGOUT");
      } catch (error) {
        console.error("Logout sırasında bir hata oluştu:", error);
        localStorage.removeItem('report_token');
        this.$router.push("/session/LOGOUT");
      }
    }
  }
};
</script>

<style scoped>
.profile-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #24252a;
  border: 1px solid #3a3b45;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  min-width: 160px;
  padding: 6px 0;
  animation: slideDown 0.15s ease-out;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

.profile-dropdown-btn {
  width: 100%;
  border: none;
  background: none;
  color: #fff;
  padding: 10px 16px;
  text-align: left;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
}

.profile-dropdown-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}
</style>
